<div class="left-pusher"></div>
<div>
  <router-outlet></router-outlet>
</div>
<div class="right-pusher"></div>
